import gql from 'graphql-tag';

const CHAT_CREATE_CHANNEL = gql`
  mutation ChatCreateChannel($listingId: String!) {
    chatCreateChannel(listingId: $listingId) {
      channelId
      members
    }
  }
`;

export const createChatChannel = client => variables =>
  client.mutate({
    mutation: CHAT_CREATE_CHANNEL,
    variables
  });

const CHAT_CREATE_SESSION = gql`
  mutation chatCreateSession {
    chatCreateSession {
      token
    }
  }
`;

export const createChatSession = client => () =>
  client.mutate({
    mutation: CHAT_CREATE_SESSION
  });
